<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">菜单管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addkf" type="primary">添加父级菜单</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除菜单</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    :placeholder="tstext"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" :expanded-row-keys.sync="expandedRowKeys"  rowKey="id" :scroll="{x: 1300}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="action" slot-scope="text,record" class="operate">
                        <!-- <a href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 跟进</a> -->
                        <a href="javascript:;" v-if="record.pid==0" @click="addckf(record.id)"><a-icon type="edit" /> 添加菜单</a>
                        <a href="javascript:;" @click="edituser(record.id)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.id)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="icon" slot-scope="text">
                        <a-icon :type="text" />
                    </span>
                    <span slot="id" slot-scope="text,record">
                        <span v-if="record.pid!=0">— </span>{{text}}
                    </span>

                    <span slot="status" slot-scope="text,record">
                        <!-- {{text}} -->
                        <a-switch checked-children="显示" un-checked-children="隐藏" :checked="text" @change="checked => onstatusChange(checked,record.id)"/>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                </a-table>

                <!-- <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div> -->
            </a-spin>
        </div>

        <!-- 添加菜单 -->
        <a-modal
        title="添加菜单"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="菜单层级">
                    <a-input v-model="pruid"  disabled />
                </a-form-item>
                <a-form-item label="菜单名称">
                    <a-input v-model="title" placeholder=""  v-decorator="['菜单名称', { rules: [{ required: true, message: '请输入菜单名称' }] }]" />
                </a-form-item>
                <a-form-item label="url地址">
                    <a-input v-model="href" placeholder="例：/orderlist" />
                </a-form-item>
                <a-form-item label="api地址">
                    <a-input v-model="href_api" placeholder="例：/system/editgroup"  />
                </a-form-item>
                <a-form-item label="图标">
                    <a-input v-model="icon" placeholder="例：mail"/>
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="sort"  placeholder="数字越小越靠前"/>
                </a-form-item>
                <a-form-item label="是否显示">
                    <a-switch checked-children="显示" un-checked-children="隐藏" default-checked @change="onChange"/>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 编辑菜单 -->
        <a-modal
        title="编辑菜单"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="菜单层级">
                    <a-input v-model="editinfo.pruid"   />
                </a-form-item>
                <a-form-item label="菜单名称">
                    <a-input v-model="editinfo.title" placeholder=""   />
                </a-form-item>
                <a-form-item label="url地址">
                    <a-input v-model="editinfo.href"   />
                </a-form-item>
                <a-form-item label="api地址">
                    <a-input v-model="editinfo.href_api" />
                </a-form-item>
                <a-form-item label="图标">
                    <a-input v-model="editinfo.icon" />
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="editinfo.sort"  />
                </a-form-item>
                <a-form-item label="是否显示">
                    <a-switch checked-children="显示" un-checked-children="隐藏" :defaultChecked="defaultc" @change="oneditChange"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id'},
    {title: '菜单名称',dataIndex: 'title',key: 'title',scopedSlots: { customRender: 'id' }},
    {title: 'url地址',dataIndex: 'href',key: 'href'},
    {title: 'api地址',dataIndex: 'href_api',key: 'href_api'},
    {title: '图标',dataIndex: 'icon',key: 'icon',scopedSlots: { customRender: 'icon' },width:'120px'},
    {title: '排序',dataIndex: 'sort',key: 'sort',width:'120px'},
    {title: '是否显示',dataIndex: 'menu_status',key: 'menu_status',scopedSlots: { customRender: 'status' }},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },width:280},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,
            tstext:"菜单",

            searchtext:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:"",

            expandedRowKeys:[],

            title:"",
            menu_status:1,
            sort:"",
            href:"",
            pruid:0,
            icon:"",

            tablex:"100%",
            delids:[],
            disabled:true,
            editinfo:{status:''},
            editid:"",
            defaultc:"",
            href_api:"",

            true:true,
            false:false,
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },

    mounted(){
        this.fetch()
        this.tablespinning=false
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };

    },
    methods:{
        // getmymenu(){
        //     this.$axios.post('/api/system/mymenulist',{
        //     },{
        //         headers: {
        //             "token":localStorage.getItem('token'),
        //         }
        //     }).then((res)=>{
        //         if(res.data.code==200){
        //         this.menu=res.data.data
        //         }else if(res.data.code==2011){
        //         localStorage.setItem('token', '');
        //         this.$router.push({ path:'/login'})
        //         }else{
        //         this.$message.warning(res.data.msg); 
        //         }
                
        //     })
        // },
        onChange(checked){
            if(checked){
                this.menu_status=1
            }else{
                this.menu_status=0
            }
        },
        oneditChange(checked){
            if(checked){
                this.editinfo.menu_status=1
            }else{
                this.editinfo.menu_status=0
            }
        },
        onstatusChange(checked,id){
            console.log(checked)
            var status;
            if(checked){
                status=1
            }else{
                status=0
            }
            this.$axios.post('/api/system/editrule',{
                ruid:id,
                menu_status:status
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 搜索
        onSearch(){

        },

        // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
            // console.log('selectedRowKeys changed: ', selectedRowKeys);
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/system/delrule',{
                ruids:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                    this.getmymenu()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },


        // 编辑
        edituser(id){
            this.editid=id
            this.$axios.post('/api/system/rulepage',{
                ruid:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                    if(res.data.data.menu_status==0){
                        this.defaultc=false
                    }else if(res.data.data.menu_status==1){
                        this.defaultc=true
                    }
                    this.editvisible=true
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        edithandleOk(){
            this.$axios.post('/api/system/editrule',{
                ruid:this.editid,
                title: this.editinfo.title,
                pruid:this.editinfo.pruid,
                menu_status:this.editinfo.menu_status,
                sort:this.editinfo.sort,
                href:this.editinfo.href,
                href_api:this.editinfo.href_api,
                icon:this.editinfo.icon
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.editvisible=false
                    this.fetch()
                    // this.getmymenu()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 添加菜单
        addkf(){
            this.pruid=0
             this.addvisible=true
        },

        addckf(id){
            this.pruid=id
            this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/system/addrule',{
                title: this.title,
                pruid:this.pruid,
                menu_status:this.menu_status,
                sort:this.sort,
                href:this.href,
                href_api:this.href_api,
                icon:this.icon
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                    // this.getmymenu()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        handleCancel(){
            this.addvisible=false
            this.editvisible=false
        },
        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/system/rulelist',{
                // pagesize: this.size,
                // page:this.currentpage,
                // sources:this.sources,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data
                    for(var i in data){
                        if(data[i].menu_status==0){
                            data[i].menu_status=false
                        }else{
                            data[i].menu_status=true
                        }
                    }
                    this.tablespinning=false
                    this.data=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/menulist.vue